module.exports = __webpack_public_path__ + "img/588x310-02.f11d5e43.png";